import React from 'react';

const Reports = () => {
  return <h2>This is the Reports Page!</h2>;
};

export default Reports;
